import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { NotificationComponent } from './notification.component';
import { NotificationMessage } from '@core/interfaces';
import { Observable } from 'rxjs';
import { selectNotification } from '@store/selectors';
import { NOTIFICATION_CLEAR } from 'src/app/store/actions';

@Injectable({
  providedIn: 'root',
})
export class NotificationPresenter {
  notification$: Observable<NotificationMessage|null>;
  view!: NotificationComponent;

  constructor(private store: Store) {
    this.notification$ = this.store.select(selectNotification);
  }

  setView(view: NotificationComponent): void {
    this.view = view; 

    this.notification$.subscribe((value: NotificationMessage| null) => {
      if (!value) return;
      
      const { type, title, detail } = value;

      this.view.showToast(type, title, detail);
      this.store.dispatch(NOTIFICATION_CLEAR());
    });
  }
}
